exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown[data-v-127327c0]{opacity:0;transition:opacity .2s;position:absolute;top:100%;right:0;pointer-events:none}.dropdown .dropdown-inner[data-v-127327c0]{border-radius:2px;background-color:#fff;box-shadow:0 0 16px 0 rgba(0,0,0,.08);min-width:300px;display:flex;flex-direction:column}.dropdown.active[data-v-127327c0]{opacity:1;pointer-events:all}.dropdown.active[data-v-127327c0]:after{opacity:1}", ""]);

// exports
